import React from 'react';
import "./Footer.css"

const Footer = () => {
    return (
        <div className="footer">
      
        <footer className="container">
            <div className="row">

            <div className="col-lg-4 col-md-3 col-sm-12">
            <div className="logo">
                    
                    <span className="air">Air</span>
                    <span className="time">Time</span>
                    
                </div>
            </div>
            <div className="col-lg-4 col-md-3 col-sm-12">
                <ul>
                    <li><a href="/">Abut ari-line</a></li>
                    <li><a href="/">Blog</a></li>
                    <li><a href="/">FQC</a></li>
                </ul>
            </div>
            <div className="col-lg-4">
                <img src="https://teacher-hub.netlify.app/static/media/card.c383a9df.png" alt="" className="img-fluid"/>
            </div>
            <div className="text-center">Copyright © Developer SUJAN 2021   </div>
            
            </div>
        </footer>
              
        </div>
    );
};

export default Footer;